// extracted by mini-css-extract-plugin
export default {"wrapper":"es-z","response":"fs-z","error":"gs-z","disabled":"hs-z","buttons":"is-z","feedbackQuestionSection":"js-z","yesNoWrapper":"ks-z"};